const getUniqueGrades = (grades: any[]): string[] => {
  if (!Array.isArray(grades)) return [];
  const normalizedGrades = grades
    .filter((grade) => typeof grade === 'string' && grade)
    .map((grade) =>
      grade.includes('-INCOMING') ? grade.replace('-INCOMING', '') : grade
    );
  return Array.from(new Set(normalizedGrades));
};

export { getUniqueGrades };
